import React, { useEffect } from "react";
import { Box, Typography, Link, Divider } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact | Kloudscan";
  }, []);

  return (
    // Full-width wrapper with background color
    <>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "white",
          py: { xs: 10, sm: 10 }, // vertical spacing
        }}
      >
        {/* Inner content container */}
        <Box
          sx={{
            maxWidth: 700,
            mx: "auto", // center content horizontally
            textAlign: "center",
            px: { xs: 3, sm: 5 },
          }}
        >
          {/* Main Heading */}
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
            Need Help?
          </Typography>
          {/* Icon */}
          <SupportAgentIcon sx={{ fontSize: 60, color: "#09b2f0", mb: 2 }} />

          <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
            Have questions about Kloudscan, account issues, or anything else?
            We’re here to assist you.
          </Typography>

          {/* FAQ Section */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
              Quick Question?
            </Typography>

            <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
              You might find what you’re looking for in our FAQ — covering
              setup, billing, and common usage questions.
            </Typography>

            <Link
              href="/faq"
              underline="hover"
              sx={{ fontWeight: 600, color: "#09b2f0" }}
            >
              Visit the FAQ →
            </Link>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Direct Support */}
          <Typography variant="body1" sx={{ mb: 2 }}>
            Still need help? Contact us directly:
          </Typography>

          <Link
            href="mailto:support@kloudscan.com"
            underline="none"
            sx={{
              display: "inline-block",
              px: 5,
              py: 1.5,
              borderRadius: "999px",
              fontSize: "1rem",
              fontWeight: 600,
              color: "#09b2f0",
              border: "2px solid #09b2f0",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "#09b2f0",
                color: "#FFFFFF",
              },
            }}
          >
            support@kloudscan.com
          </Link>

          <Typography
            variant="caption"
            sx={{ display: "block", mt: 2, color: "text.secondary" }}
          >
            We typically respond within 1 business day.
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Contact;
